import React, { useEffect } from "react";

// Theme style
import "./lightTheme.scss";

//Redux
import { useSelector } from "react-redux";


const MessageSystem = ({ msg, striped, id }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <>
      <div
        className={`eventComponent ${mainTheme === "dark" ? "dark" : "light"} ${striped ? "striped" : "default"}`}
        id={id}
      >
        <li>
          <div className="sectionTitle">
            <span className="title">{msg}</span>
          </div>
        </li>
      </div>
    </>
  );
};
export default MessageSystem;
